// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationFR from './i18n/fr.json';
import translationES from './i18n/es.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: translationFR },
      es: { translation: translationES }
    },
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
